module.exports = __webpack_public_path__ + "static/media/yuce007.05d003e3.png";